import { useTranslation } from 'react-i18next'
import { usePagination, DOTS } from '../../hooks/use-pagination'
import { MenuItem, TextField } from '@mui/material'
import { textFieldWhiteBg } from '../../theme/custom-styles'

const Pagination = ({
  handleChangePageSize,
  handlePaginationPageChange,
  totalCount,
  siblingCount = 1,
  currentPage,
  pageSize
}: {
  handleChangePageSize?: (pageSize: string) => void
  handlePaginationPageChange: (page: number) => void
  totalCount: number
  siblingCount?: number
  currentPage: number
  pageSize: number
}) => {
  const { t } = useTranslation(['common'])
  const paginationRange =
    usePagination({
      currentPage,
      totalCount,
      siblingCount,
      pageSize
    }) ?? []

  let lastPage = paginationRange[paginationRange.length - 1]

  if (currentPage === 0 || paginationRange.length < 2) return null

  return (
    <div style={{ display: 'flex', gap: '15px', overflow: 'hidden' }}>
      <ul className="pagination-container">
        {currentPage > 1 && (
          <li
            className="pagination-border-item"
            style={{ marginRight: '15px' }}
            onClick={() => {
              handlePaginationPageChange(1)
            }}
          >
            <div className="arrow left" />
            <div className="pagination-border-item-text">{t('pagination.start')}</div>
          </li>
        )}
        {paginationRange.map((pageNumber, index) => {
          if (pageNumber === DOTS) {
            return (
              <li
                key={index}
                className="pagination-item dots"
              >
                &#8230;
              </li>
            )
          }

          return (
            <li
              key={index}
              className={pageNumber === currentPage ? 'pagination-item selected' : 'pagination-item'}
              onClick={() => {
                if (isNaN(Number(pageNumber))) return

                handlePaginationPageChange(Number(pageNumber))
              }}
            >
              {pageNumber}
            </li>
          )
        })}
        {Number(currentPage) < Number(lastPage) && (
          <li
            style={{ marginLeft: '15px' }}
            className="pagination-border-item"
            onClick={() => {
              handlePaginationPageChange(Number(lastPage))
            }}
          >
            <div className="pagination-border-item-text">{t('pagination.end')}</div>
            <div className="arrow right" />
          </li>
        )}
      </ul>
      <div style={{ marginTop: '35px' }}>
        <TextField
          select
          label={t('pagination.show')}
          variant="standard"
          value={String(pageSize)}
          onChange={(event) => handleChangePageSize?.(event.target.value)}
          sx={{ ...textFieldWhiteBg, '& .MuiInputBase-root .MuiSelect-select': { boxSizing: 'border-box', textAlign: 'start', minWidth: '150px' } }}
        >
          <MenuItem value="10">10</MenuItem>
          <MenuItem value="25">25</MenuItem>
          <MenuItem value="50">50</MenuItem>
          <MenuItem value="100">100</MenuItem>
        </TextField>
      </div>
    </div>
  )
}

export default Pagination
